import api from '../api';
import { tokenService } from '../auth/tokenService';

export const usersList = {
  getDataUser: async (params) => {
    try {
      const response = await api.get('users/cms/filtered/paginated', {
        params,
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  createUser: async (userData) => {
    try {
      const response = await api.post('users/cms', userData, {
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateUser: async (userData) => {
    try {
      const response = await api.put(`users/cms/${userData.id}`, userData, {
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  downloadUsers: async (params) => {
    try {
      const response = await api.get('users/cms/export/excel', {
        responseType: 'blob',
        params,
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`,
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      });

      // Crear el blob y el enlace de descarga
      const blob = new Blob([response.data], { 
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'users.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return response.data;
    } catch (error) {
      throw error;
    }
  },

// En index.js - actualiza updateProfilePhoto
updateProfilePhoto: async (formData, userId) => {
    try {
      const url = `${process.env.REACT_APP_API_URL}/profiles/cms/user/${userId}/photo`;
      
      // IMPORTANTE: No establecer Content-Type manualmente, el navegador lo hará
      // con el boundary correcto para multipart/form-data
      const requestConfig = {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        },
        body: formData
      };

      console.log('Enviando imagen al servidor...', {
        url,
        headers: requestConfig.headers,
        body: formData
      });

      const res = await fetch(url, requestConfig);
      
      if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        throw new Error(errorData.message || `HTTP error! status: ${res.status}`);
      }

      const data = await res.json();
      console.log('Respuesta del servidor:', data);
      return data;
    } catch (error) {
      console.error("Error updating profile photo:", error);
      throw error; // Propagar el error para manejarlo en el componente
    }
  },

  changePassword: async (formData) => {
    try {
      const response = await api.post('/users/me/change-password', formData, {
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateProfile: async (formData, userId) => {
    try {
      const response = await api.put(`users/${userId}/update-full`, formData, {
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

